import React, { FunctionComponent } from 'react'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import SmallBodyFont from '../../../Theme/Fonts/SmallBody'
import MoreIcon from '../../../BaseComponents/Icons/MoreIcon'
import { LiveEventProps } from '../EventTypes'
import LabelFont from '../../../Theme/Fonts/Label'
import HighlightRow from '../../HighlightRow'
import LiveIndicator from './LiveIndicator'

const SIDE_WIDTH = 35

const LiveEventRow: FunctionComponent<Omit<LiveEventProps, 'type'>> = ({
    liveInfo,
    onPressEvent,
    onPressMore,
    testID,
    eventStartTime,
    hideLiveIndicator,
    caption,
    paddingTop = 4,
    borderRadius,
    onPressVideoButton,
    videoButtonHref,
    videoButtonText,
}) => {
    return (
        <Grid
            backgroundColor="pearl"
            paddingTop={paddingTop}
            paddingBottom={4}
            paddingY={4}
            paddingX={11}
            noExpand
            horizontal
            testID={testID}
            borderRadius={borderRadius}
        >
            <Touchable onPress={onPressEvent}>
                <Grid noExpand width={SIDE_WIDTH}>
                    <LiveIndicator liveInfo={liveInfo} hideLiveIndicator={hideLiveIndicator} />
                </Grid>
            </Touchable>
            <Grid noExpand width="100%">
                <Touchable onPress={onPressEvent}>
                    <Grid position="relative" noExpand center horizontal>
                        <Grid centerVertical noExpand center>
                            <Grid
                                centerVertical
                                noExpand
                                horizontal
                                paddingX={2}
                                backgroundColor="onyx-5"
                                borderRadius={1}
                            >
                                <SmallBodyFont bold color="pearl">
                                    {`${eventStartTime} -`}
                                </SmallBodyFont>
                                <SmallBodyFont bold color="onyx-5">
                                    -
                                </SmallBodyFont>
                                <SmallBodyFont bold color="ORANGE">
                                    LIVE
                                </SmallBodyFont>
                            </Grid>
                            {caption ? (
                                <Grid marginTop={2}>
                                    <LabelFont numberOfLines={1} color="keshi-3">
                                        {caption}
                                    </LabelFont>
                                </Grid>
                            ) : null}
                        </Grid>
                    </Grid>
                </Touchable>
                {onPressVideoButton || videoButtonHref ? (
                    <HighlightRow
                        text={videoButtonText}
                        onPress={onPressVideoButton}
                        href={videoButtonHref}
                        marginTop={3}
                    />
                ) : null}
            </Grid>

            <Grid noExpand width={SIDE_WIDTH}>
                <Touchable onPress={onPressMore}>
                    <Grid alignRight>
                        <MoreIcon />
                    </Grid>
                </Touchable>
            </Grid>
        </Grid>
    )
}

export default LiveEventRow
